import { z } from "zod";

export const contractsSummarySchema = z.object({
  total_amount: z.number().or(z.string().transform(Number)),
  total_spend_till_now: z.number().or(z.string().transform(Number)),
  estimated_total_spend: z.number().or(z.string().transform(Number)),
  average_daily_spend: z.number().or(z.string().transform(Number)),
});

export type ContractsSummary = z.infer<typeof contractsSummarySchema>;

export const contractItemSchema = z
  .object({
    rk: z.string(),
    contract_number: z.number().nullable().optional(),
    start_date: z.string(),
    end_date: z.string(),
    expiration_date: z.string().nullable().optional(),
    contract_item: z.string(),
    currency: z.string(),
    amount: z.number().or(z.string().transform(Number)),
    contract_modified_date: z.string(),
    published_tag: z.string().optional().nullable(),
    publisher_last_updated_epoch_ms: z
      .number()
      .or(z.string().transform(Number))
      .optional()
      .nullable(),
  })
  .passthrough();

export type ContractItem = z.infer<typeof contractItemSchema>;
